import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withTranslator } from '@wh/ui-translations';
import { find } from 'lodash';

import ChangeComponentModal, { changeComponentModalPropTypes } from '../ChangeComponentModal';
import { MESSAGE_BUS_TOPICS } from '../../../constants';

import './changeComponent.scss';

class ChangeComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            openedModal: false,
            selectedEventName: this.getEventName(props.eventId),
        };
    }

    getEventName = (eventId) => {
        const { events } = this.props;
        const event = find(events, (event) => event.id === eventId);
        return event ? event.name : '';
    };

    trackAnalytics = (currentEvent, newSelectedEvent) => {
        const payload = { currentEvent };
        if (!newSelectedEvent) {
            payload.interaction = this.state.openedModal ? 'Close' : 'Open';
        } else {
            payload.newSelectedEvent = newSelectedEvent;
        }
        window.WH.messageBus.publish(MESSAGE_BUS_TOPICS.ANALYTIC_CHANGE_COMPONENT, payload);
    };

    openModal = () => {
        this.setState({ openedModal: true });
    };

    onOpenModal = () => {
        this.trackAnalytics(this.state.selectedEventName);
        this.openModal();
    };

    closeModal = () => {
        this.setState({ openedModal: false });
    };

    onCloseModal = () => {
        this.trackAnalytics(this.state.selectedEventName);
        this.closeModal();
    };

    onClickEventItem = (event, url) => {
        event.preventDefault();
        const newSelectedEventName = this.getEventName(url.split('/')[4]);
        this.trackAnalytics(this.state.selectedEventName, newSelectedEventName);
        window.WH.messageBus.publish('internalRoute', { url });
        this.closeModal();
    };

    render() {
        const { openedModal } = this.state;
        const { events, t, eventId, sportName, locale, competitionName } = this.props;
        return (
            <div>
                {events.length > 1 && (
                    <span onClick={this.onOpenModal} styleName="change-component">
                        {t('ui-kit', 'common')('change')}
                    </span>
                )}
                {openedModal && (
                    <ChangeComponentModal
                        events={events}
                        closeModal={this.onCloseModal}
                        eventId={eventId}
                        sportName={sportName}
                        locale={locale}
                        competitionName={competitionName}
                        onClickEventItem={this.onClickEventItem}
                    />
                )}
            </div>
        );
    }
}

ChangeComponent.propTypes = {
    t: PropTypes.func.isRequired,
    ...changeComponentModalPropTypes,
};

export default withTranslator(ChangeComponent);
